/* ============================================
   YAMMIES HOUSE LUXURY THEME — Main JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // ---- STICKY HEADER ----
  const header = document.querySelector('.site-header');
  if (header) {
    const announcementBar = document.querySelector('.announcement-bar');
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ---- MOBILE MENU ----
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
  }

  // ---- CART DRAWER ----
  const cartTrigger = document.querySelector('.cart-trigger');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('.cart-close');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (cartTrigger) cartTrigger.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- SCROLL ANIMATIONS ----
  const fadeElements = document.querySelectorAll('.fade-up');
  
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = (i * 0.05) + 's';
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    fadeElements.forEach(el => observer.observe(el));
  } else {
    fadeElements.forEach(el => el.classList.add('visible'));
  }

  // ---- PRODUCT VARIANT SELECTION ----
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.variant-options');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        // Update label
        const section = this.closest('.variant-section');
        if (section) {
          const labelSpan = section.querySelector('.variant-label span');
          if (labelSpan) labelSpan.textContent = this.textContent;
        }
      }
    });
  });

  // ---- FILTER BUTTONS ----
  const filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      filterBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ---- QUICK ADD TO CART ----
  const quickAddBtns = document.querySelectorAll('.product-quick-add');
  quickAddBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const originalText = this.textContent;
      this.textContent = 'Added ✓';
      this.style.background = '#2a5c2a';
      this.style.color = '#fff';
      setTimeout(() => {
        this.textContent = originalText;
        this.style.background = '';
        this.style.color = '';
      }, 1800);
      updateCartCount(1);
    });
  });

  // ---- CART COUNT ----
  function updateCartCount(add) {
    const badge = document.querySelector('.cart-count');
    if (badge) {
      let count = parseInt(badge.textContent) || 0;
      count += add;
      badge.textContent = count;
      badge.style.transform = 'scale(1.4)';
      setTimeout(() => badge.style.transform = '', 300);
    }
  }

  // ---- NEWSLETTER FORM ----
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn = this.querySelector('.btn');
      if (input && btn) {
        const originalText = btn.textContent;
        btn.textContent = 'Subscribed ✓';
        input.value = '';
        setTimeout(() => btn.textContent = originalText, 3000);
      }
    });
  });

  // ---- PRODUCT GALLERY THUMBS ----
  const thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ---- MARQUEE DUPLICATE ----
  const marqueeTrack = document.querySelector('.marquee-track');
  if (marqueeTrack) {
    const clone = marqueeTrack.innerHTML;
    marqueeTrack.innerHTML += clone;
  }

  // ---- SMOOTH ANCHOR SCROLLING ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- ACTIVE NAV LINK ----
  const currentPath = window.location.pathname;
  document.querySelectorAll('.main-nav a').forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

});
